import type { TrackingService } from './index';
import type { TrackingResponse, TrackingRequest, BulkTrackingRequest } from './types';
import delay from '../mockServiceDelay';

export const mockTrackingService: TrackingService = {
  getTrackingByShipiumTrackingId: async (shipiumTrackingId: string): Promise<TrackingResponse> => {
    await delay();
    return {
      shipiumTrackingId: shipiumTrackingId,
      carrierId: 'cdl',
      carrierTrackingId: '1CDLR9JJ1AFCKZR',
      carrierServiceMethodId: 'cdl-service-method',
      shipmentStatus: 'Delivered',
      shippedDateTime: '2022-10-31T22:11:00Z',
      deliveredAtDateTime: '2022-11-01T10:59:00-04:00',
      carrierEstimatedDeliveryDate: '2022-11-01T00:00:00-04:00',
      trackingEvents: [
        {
          carrierDescription: 'Package has been delivered.',
          shipmentStatus: 'Delivered',
          eventDate: '2022-11-01T14:59:00Z',
          postalCode: '19734',
          country: 'US',
          city: 'Townsend',
          region: 'DE',
        },
        {
          carrierDescription: 'Package In Transit',
          shipmentStatus: 'In Transit',
          eventDate: '2022-11-01T11:29:00Z',
          postalCode: '19802',
          country: 'US',
          city: 'Wilmington',
          region: 'DE',
        },
        {
          carrierDescription: 'CDL Origin Scan',
          shipmentStatus: 'In Transit',
          eventDate: '2022-10-31T22:11:00Z',
          postalCode: '07073',
          country: 'US',
          city: 'Kearny',
          region: 'NJ',
        },
        {
          carrierDescription: 'Information about the package received.',
          shipmentStatus: 'Label Printed',
          eventDate: '2022-10-29T12:47:00Z',
          postalCode: '07073',
          country: 'US',
          city: 'Kearny',
          region: 'NJ',
        },
      ],
    };
  },
  getTrackingByCarrierTrackingId: async (carrierTrackingId: string, carrierId: string): Promise<TrackingResponse> => {
    await delay();
    return {
      shipiumTrackingId: 'shipiumId',
      carrierId: carrierId,
      carrierTrackingId: carrierTrackingId,
      carrierServiceMethodId: 'cdl-service-method',
      shipmentStatus: 'Delivered',
      shippedDateTime: '2022-10-31T22:11:00Z',
      deliveredAtDateTime: '2022-11-01T10:59:00-04:00',
      carrierEstimatedDeliveryDate: '2022-11-01T00:00:00-04:00',
      trackingEvents: [
        {
          carrierDescription: 'Package has been delivered.',
          shipmentStatus: 'Delivered',
          eventDate: '2022-11-01T14:59:00Z',
          postalCode: '19734',
          country: 'US',
          city: 'Townsend',
          region: 'DE',
        },
        {
          carrierDescription: 'Package In Transit',
          shipmentStatus: 'In Transit',
          eventDate: '2022-11-01T11:29:00Z',
          postalCode: '19802',
          country: 'US',
          city: 'Wilmington',
          region: 'DE',
        },
        {
          carrierDescription: 'CDL Origin Scan',
          shipmentStatus: 'In Transit',
          eventDate: '2022-10-31T22:11:00Z',
          postalCode: '07073',
          country: 'US',
          city: 'Kearny',
          region: 'NJ',
        },
        {
          carrierDescription: 'Information about the package received.',
          shipmentStatus: 'Label Printed',
          eventDate: '2022-10-29T12:47:00Z',
          postalCode: '07073',
          country: 'US',
          city: 'Kearny',
          region: 'NJ',
        },
      ],
    };
  },
  bulkCarrierTrackingSearch: async (payload: TrackingRequest): Promise<TrackingResponse[]> => {
    // updated so that return info
    // matches a little more with what was searched
    await delay();
    return [
      {
        shipiumTrackingId: '83414f1e-b22a-4581-ab29-732f83cb45ab',
        carrierId: 'cdl',
        carrierTrackingId: '1CDLR9JJ1AFCKZR',
        carrierServiceMethodId: 'cdl-service-method',
        shipmentStatus: 'Delivered',
        shippedDateTime: '2022-10-31T22:11:00Z',
        deliveredAtDateTime: '2022-11-01T10:59:00-04:00',
        carrierEstimatedDeliveryDate: '2022-11-01T00:00:00-04:00',
        trackingEvents: [
          {
            carrierDescription: 'Package has been delivered.',
            shipmentStatus: 'Delivered',
            eventDate: '2022-11-01T14:59:00Z',
            postalCode: '19734',
            country: 'US',
            city: 'Townsend',
            region: 'DE',
          },
          {
            carrierDescription: 'Package In Transit',
            shipmentStatus: 'In Transit',
            eventDate: '2022-11-01T11:29:00Z',
            postalCode: '19802',
            country: 'US',
            city: 'Wilmington',
            region: 'DE',
          },
          {
            carrierDescription: 'CDL Origin Scan',
            shipmentStatus: 'In Transit',
            eventDate: '2022-10-31T22:11:00Z',
            postalCode: '07073',
            country: 'US',
            city: 'Kearny',
            region: 'NJ',
          },
          {
            carrierDescription: 'Information about the package received.',
            shipmentStatus: 'Label Printed',
            eventDate: '2022-10-29T12:47:00Z',
            postalCode: '07073',
            country: 'US',
            city: 'Kearny',
            region: 'NJ',
          },
        ],
      },
      {
        shipiumTrackingId: 'a4614936-9f85-4f9d-aee4-d14a780bdc23',
        carrierId: 'airterra',
        carrierTrackingId: 'AT000050001100007624',
        carrierServiceMethodId: 'airterra-groundxc-service-method',
        shipmentStatus: 'In Transit',
        shippedDateTime: '2022-11-01T22:34:05.780622Z',
        deliveredAtDateTime: null,
        carrierEstimatedDeliveryDate: '2022-11-04T00:00:00-05:00',
        trackingEvents: [
          {
            carrierDescription: 'Received by AirTerra',
            shipmentStatus: 'In Transit',
            eventDate: '2022-11-01T22:34:05.7806216Z',
            postalCode: '18202',
            country: null,
            city: 'Hazleton',
            region: 'PA',
          },
        ],
      },
      {
        shipiumTrackingId: '4f9c62c3-02f4-4e27-b408-c49a6f9fb970',
        carrierId: 'ontrac',
        carrierTrackingId: 'D10013440363874',
        carrierServiceMethodId: 'ontrac-ground-service-method',
        shipmentStatus: 'Delivered',
        shippedDateTime: '2022-11-01T20:17:00Z',
        deliveredAtDateTime: '2022-11-02T11:34:00-07:00',
        carrierEstimatedDeliveryDate: '2022-11-01T17:00:00-07:00',
        trackingEvents: [
          {
            carrierDescription: 'Delivered - Consignment left',
            shipmentStatus: 'Delivered',
            eventDate: '2022-11-02T18:34:00Z',
            postalCode: '99205',
            country: 'US',
            city: 'SPOKANE',
            region: 'WA',
          },
          {
            carrierDescription: 'Out for delivery',
            shipmentStatus: 'Out For Delivery',
            eventDate: '2022-11-02T16:07:00Z',
            postalCode: '99205',
            country: 'US',
            city: 'SPOKANE',
            region: 'WA',
          },
          {
            carrierDescription: 'Package arrived at destination facility',
            shipmentStatus: 'In Transit',
            eventDate: '2022-11-02T15:04:00Z',
            postalCode: '99224',
            country: 'US',
            city: 'SPOKANE',
            region: 'WA',
          },
          {
            carrierDescription: 'Origination scan - Package scanned at facility',
            shipmentStatus: 'In Transit',
            eventDate: '2022-11-01T20:17:00Z',
            postalCode: '89506',
            country: 'US',
            city: 'Reno',
            region: 'NV',
          },
          {
            carrierDescription: 'Shipping label created; data received',
            shipmentStatus: 'Label Printed',
            eventDate: '2022-10-31T22:23:00Z',
            postalCode: '89506',
            country: 'US',
            city: 'Reno',
            region: 'NV',
          },
        ],
      },
      {
        shipiumTrackingId: '4b49b299-fc7e-4187-819f-11ec77350f13',
        carrierId: 'cdl',
        carrierTrackingId: '1CDLJZKBA9F3K8E',
        carrierServiceMethodId: 'cdl-service-method',
        shipmentStatus: 'Delivered',
        shippedDateTime: '2022-10-31T22:34:00Z',
        deliveredAtDateTime: '2022-11-01T12:43:00-04:00',
        carrierEstimatedDeliveryDate: '2022-11-01T00:00:00-04:00',
        trackingEvents: [
          {
            carrierDescription: 'Package has been delivered.',
            shipmentStatus: 'Delivered',
            eventDate: '2022-11-01T16:43:00Z',
            postalCode: '08090',
            country: 'US',
            city: 'Wenonah',
            region: 'NJ',
          },
          {
            carrierDescription: 'Package In Transit',
            shipmentStatus: 'In Transit',
            eventDate: '2022-11-01T11:32:00Z',
            postalCode: '08086',
            country: 'US',
            city: 'Westampton',
            region: 'NJ',
          },
          {
            carrierDescription: 'CDL Origin Scan',
            shipmentStatus: 'In Transit',
            eventDate: '2022-10-31T22:34:00Z',
            postalCode: '07073',
            country: 'US',
            city: 'Kearny',
            region: 'NJ',
          },
          {
            carrierDescription: 'Information about the package received.',
            shipmentStatus: 'Label Printed',
            eventDate: '2022-10-29T12:47:00Z',
            postalCode: '07073',
            country: 'US',
            city: 'Kearny',
            region: 'NJ',
          },
        ],
      },
    ];
  },
  bulkTrackingSearch: async (payload: BulkTrackingRequest): Promise<TrackingResponse[]> => {
    // updated so that return info
    // matches a little more with what was searched
    await delay();
    return [
      {
        shipiumTrackingId: '83414f1e-b22a-4581-ab29-732f83cb45ab',
        carrierId: 'cdl',
        carrierTrackingId: '1CDLR9JJ1AFCKZR',
        carrierServiceMethodId: 'cdl-service-method',
        shipmentStatus: 'Delivered',
        shippedDateTime: '2022-10-31T22:11:00Z',
        deliveredAtDateTime: '2022-11-01T10:59:00-04:00',
        carrierEstimatedDeliveryDate: '2022-11-01T00:00:00-04:00',
        trackingEvents: [
          {
            carrierDescription: 'Package has been delivered.',
            shipmentStatus: 'Delivered',
            eventDate: '2022-11-01T14:59:00Z',
            postalCode: '19734',
            country: 'US',
            city: 'Townsend',
            region: 'DE',
          },
          {
            carrierDescription: 'Package In Transit',
            shipmentStatus: 'In Transit',
            eventDate: '2022-11-01T11:29:00Z',
            postalCode: '19802',
            country: 'US',
            city: 'Wilmington',
            region: 'DE',
          },
          {
            carrierDescription: 'CDL Origin Scan',
            shipmentStatus: 'In Transit',
            eventDate: '2022-10-31T22:11:00Z',
            postalCode: '07073',
            country: 'US',
            city: 'Kearny',
            region: 'NJ',
          },
          {
            carrierDescription: 'Information about the package received.',
            shipmentStatus: 'Label Printed',
            eventDate: '2022-10-29T12:47:00Z',
            postalCode: '07073',
            country: 'US',
            city: 'Kearny',
            region: 'NJ',
          },
        ],
      },
      {
        shipiumTrackingId: 'a4614936-9f85-4f9d-aee4-d14a780bdc23',
        carrierId: 'airterra',
        carrierTrackingId: 'AT000050001100007624',
        carrierServiceMethodId: 'airterra-groundxc-service-method',
        shipmentStatus: 'In Transit',
        shippedDateTime: '2022-11-01T22:34:05.780622Z',
        deliveredAtDateTime: null,
        carrierEstimatedDeliveryDate: '2022-11-04T00:00:00-05:00',
        trackingEvents: [
          {
            carrierDescription: 'Received by AirTerra',
            shipmentStatus: 'In Transit',
            eventDate: '2022-11-01T22:34:05.7806216Z',
            postalCode: '18202',
            country: null,
            city: 'Hazleton',
            region: 'PA',
          },
        ],
      },
      {
        shipiumTrackingId: '4f9c62c3-02f4-4e27-b408-c49a6f9fb970',
        carrierId: 'ontrac',
        carrierTrackingId: 'D10013440363874',
        carrierServiceMethodId: 'ontrac-ground-service-method',
        shipmentStatus: 'Delivered',
        shippedDateTime: '2022-11-01T20:17:00Z',
        deliveredAtDateTime: '2022-11-02T11:34:00-07:00',
        carrierEstimatedDeliveryDate: '2022-11-01T17:00:00-07:00',
        trackingEvents: [
          {
            carrierDescription: 'Delivered - Consignment left',
            shipmentStatus: 'Delivered',
            eventDate: '2022-11-02T18:34:00Z',
            postalCode: '99205',
            country: 'US',
            city: 'SPOKANE',
            region: 'WA',
          },
          {
            carrierDescription: 'Out for delivery',
            shipmentStatus: 'Out For Delivery',
            eventDate: '2022-11-02T16:07:00Z',
            postalCode: '99205',
            country: 'US',
            city: 'SPOKANE',
            region: 'WA',
          },
          {
            carrierDescription: 'Package arrived at destination facility',
            shipmentStatus: 'In Transit',
            eventDate: '2022-11-02T15:04:00Z',
            postalCode: '99224',
            country: 'US',
            city: 'SPOKANE',
            region: 'WA',
          },
          {
            carrierDescription: 'Origination scan - Package scanned at facility',
            shipmentStatus: 'In Transit',
            eventDate: '2022-11-01T20:17:00Z',
            postalCode: '89506',
            country: 'US',
            city: 'Reno',
            region: 'NV',
          },
          {
            carrierDescription: 'Shipping label created; data received',
            shipmentStatus: 'Label Printed',
            eventDate: '2022-10-31T22:23:00Z',
            postalCode: '89506',
            country: 'US',
            city: 'Reno',
            region: 'NV',
          },
        ],
      },
      {
        shipiumTrackingId: '4b49b299-fc7e-4187-819f-11ec77350f13',
        carrierId: 'cdl',
        carrierTrackingId: '1CDLJZKBA9F3K8E',
        carrierServiceMethodId: 'cdl-service-method',
        shipmentStatus: 'Delivered',
        shippedDateTime: '2022-10-31T22:34:00Z',
        deliveredAtDateTime: '2022-11-01T12:43:00-04:00',
        carrierEstimatedDeliveryDate: '2022-11-01T00:00:00-04:00',
        trackingEvents: [
          {
            carrierDescription: 'Package has been delivered.',
            shipmentStatus: 'Delivered',
            eventDate: '2022-11-01T16:43:00Z',
            postalCode: '08090',
            country: 'US',
            city: 'Wenonah',
            region: 'NJ',
          },
          {
            carrierDescription: 'Package In Transit',
            shipmentStatus: 'In Transit',
            eventDate: '2022-11-01T11:32:00Z',
            postalCode: '08086',
            country: 'US',
            city: 'Westampton',
            region: 'NJ',
          },
          {
            carrierDescription: 'CDL Origin Scan',
            shipmentStatus: 'In Transit',
            eventDate: '2022-10-31T22:34:00Z',
            postalCode: '07073',
            country: 'US',
            city: 'Kearny',
            region: 'NJ',
          },
          {
            carrierDescription: 'Information about the package received.',
            shipmentStatus: 'Label Printed',
            eventDate: '2022-10-29T12:47:00Z',
            postalCode: '07073',
            country: 'US',
            city: 'Kearny',
            region: 'NJ',
          },
        ],
      },
    ];
  },
};
